import PropTypes from 'prop-types';

const ScanSvg = ({ width, height, palette = [] }) => {
  return (
    <svg
      width={`${width || 60}`}
      height={`${height || 60}`}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.2344 52.8516H14.7656C13.7948 52.8516 13.0078 52.0645 13.0078 51.0938V8.90625C13.0078 7.93547 13.7948 7.14844 14.7656 7.14844H45.2344C46.2052 7.14844 46.9922 7.93547 46.9922 8.90625V51.0938C46.9922 52.0645 46.2052 52.8516 45.2344 52.8516Z"
        fill={`url(#paint0_linear_50_8568${width + height})`}
      />
      <path
        d="M52.2656 31.7578H7.73438C6.76359 31.7578 5.97656 30.9708 5.97656 30C5.97656 29.0292 6.76359 28.2422 7.73438 28.2422H52.2656C53.2364 28.2422 54.0234 29.0292 54.0234 30C54.0234 30.9708 53.2364 31.7578 52.2656 31.7578ZM54.0234 11.1328V1.75781C54.0234 0.787031 53.2364 0 52.2656 0H42.8906C41.9198 0 41.1328 0.787031 41.1328 1.75781C41.1328 2.72859 41.9198 3.51562 42.8906 3.51562H50.5078V11.1328C50.5078 12.1036 51.2948 12.8906 52.2656 12.8906C53.2364 12.8906 54.0234 12.1036 54.0234 11.1328ZM18.8672 58.2422C18.8672 57.2714 18.0802 56.4844 17.1094 56.4844H9.49219V48.8672C9.49219 47.8964 8.70516 47.1094 7.73438 47.1094C6.76359 47.1094 5.97656 47.8964 5.97656 48.8672V58.2422C5.97656 59.213 6.76359 60 7.73438 60H17.1094C18.0802 60 18.8672 59.213 18.8672 58.2422ZM9.49219 11.1328V3.51562H17.1094C18.0802 3.51562 18.8672 2.72859 18.8672 1.75781C18.8672 0.787031 18.0802 0 17.1094 0H7.73438C6.76359 0 5.97656 0.787031 5.97656 1.75781V11.1328C5.97656 12.1036 6.76359 12.8906 7.73438 12.8906C8.70516 12.8906 9.49219 12.1036 9.49219 11.1328ZM54.0234 58.2422V48.8672C54.0234 47.8964 53.2364 47.1094 52.2656 47.1094C51.2948 47.1094 50.5078 47.8964 50.5078 48.8672V56.4844H42.8906C41.9198 56.4844 41.1328 57.2714 41.1328 58.2422C41.1328 59.213 41.9198 60 42.8906 60H52.2656C53.2364 60 54.0234 59.213 54.0234 58.2422ZM30.5859 15.9375C30.5859 14.9667 29.7989 14.1797 28.8281 14.1797H21.7969C20.8261 14.1797 20.0391 14.9667 20.0391 15.9375C20.0391 16.9083 20.8261 17.6953 21.7969 17.6953H28.8281C29.7989 17.6953 30.5859 16.9083 30.5859 15.9375ZM37.6172 22.9688C37.6172 21.998 36.8302 21.2109 35.8594 21.2109H21.7969C20.8261 21.2109 20.0391 21.998 20.0391 22.9688C20.0391 23.9395 20.8261 24.7266 21.7969 24.7266H35.8594C36.8302 24.7266 37.6172 23.9395 37.6172 22.9688ZM32.9297 37.0312C32.9297 36.0605 32.1427 35.2734 31.1719 35.2734H21.7969C20.8261 35.2734 20.0391 36.0605 20.0391 37.0312C20.0391 38.002 20.8261 38.7891 21.7969 38.7891H31.1719C32.1427 38.7891 32.9297 38.002 32.9297 37.0312ZM39.9609 44.0625C39.9609 43.0917 39.1739 42.3047 38.2031 42.3047H21.7969C20.8261 42.3047 20.0391 43.0917 20.0391 44.0625C20.0391 45.0333 20.8261 45.8203 21.7969 45.8203H38.2031C39.1739 45.8203 39.9609 45.0333 39.9609 44.0625Z"
        fill={`url(#paint1_linear_50_8568${width + height})`}
      />
      <defs>
        <linearGradient
          id={`paint0_linear_50_8568${width + height}`}
          x1="30"
          y1="52.8516"
          x2="30"
          y2="7.14844"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[2]} />
          <stop offset="1" stopColor={palette[3]} />
        </linearGradient>
        <linearGradient
          id={`paint1_linear_50_8568${width + height}`}
          x1="30"
          y1="60"
          x2="30"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[0]} />
          <stop offset="1" stopColor={palette[1]} />
        </linearGradient>
      </defs>
    </svg>
  );
};

ScanSvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  palette: PropTypes.arrayOf(PropTypes.string),
};

export default ScanSvg;
